import Image from "next/image";
import PropTypes from "prop-types";

const QuestionPill = ({ item, index, expandedPill, setPillAsExpanded }) => (
  <div
    onClick={() =>
      expandedPill !== index ? setPillAsExpanded(index) : setPillAsExpanded(-1)
    }
    className="flex flex-col space-y-6 w-full md:w-3/5 cursor-pointer"
    key={item.id}
  >
    <div
      className="p-8 space-y-4"
      style={{
        boxShadow: "0px 5px 25px rgba(42, 52, 61, 0.08)",
        borderRadius: "6px"
      }}
    >
      <div className="flex justify-between items-center space-x-4">
        <p className="flex-grow font-bold">{item.question}</p>
        <div className="flex-shrink-0">
          <Image
            alt="Expand and contract"
            height="24"
            width="24"
            src={expandedPill === index ? "/contract.svg" : "/expand.svg"}
          />
        </div>
      </div>
      {item.simpleAnswer ? (
        <div className={`${expandedPill === index ? "" : "hidden"}`}>
          <p dangerouslySetInnerHTML={{ __html: item.simpleAnswer }} />
        </div>
      ) : (
        <div className={`${expandedPill === index ? "" : "hidden"}`}>
          {item.structuredAnswer()}
        </div>
      )}
    </div>
  </div>
);

QuestionPill.propTypes = {
  item: PropTypes.object,
  index: PropTypes.number,
  expandedPill: PropTypes.number,
  setPillAsExpanded: PropTypes.func
};

export default QuestionPill;
